import { takeLatest, put, call } from "redux-saga/effects";
import axios from "axios";
import {
  addBullionRates,
  getBullionRates,
  setBullionRates,
  setMessage,
  setError,
  getMetals,
  setMetals,
  fetchMetals,
  fetchMetalsSuccess,
  fetchMetalsFailure,
  getLiveRates,
  getLiveRatesSuccess,
  getLiveRatesFailure,
} from "../slices/metalRateSlice";
import { toast } from "react-toastify";

function* handleAddBullionRate(action) {
  try {
    const payloadArray = Array.isArray(action.payload)
      ? action.payload
      : [action.payload];

    const res = yield axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-rates/addBullionRates`,
      payloadArray,
    );

    if (res.data.success) {
      // ✅ Show success toast
      toast.success(res.data.message || "Bullion Rate Added successfully");

      // Save message in Redux
      yield put(
        setMessage(res.data.message || "Bullion Rate Added successfully"),
      );

      // Refresh metals
      yield put(fetchMetals());
    } else {
      // ❌ Show info toast (from backend or fallback)
      toast.info(res.data.message || "Something went wrong, please try again.");
    }
  } catch (error) {
    // ❌ Handle unexpected errors
    toast.error(error.message || "Failed to add bullion rate.");
  }
}

function* handleGetMetals(action) {
  try {
    let payload = action.payload;
    console.log("action.==", payload);
    const res = yield axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/getMetals`,
      action.payload,
    );
    const metals = res?.data?.value || [];
    console.log("res", res.data.errormsg);
    if (res?.data?.errormsg) {
      yield put(setError(res.data.errormsg || "Something wrong!"));
      return;
    }
    yield put(setMetals(res.data.data));
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to get metal"));
  }
}

function* handleGetBullionRates(action) {
  try {
    let payload = action.payload;
    console.log("action.==", payload);
    const res = yield axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-rates/getStateWiseBullionRates`,
      action.payload,
    );
    const metals = res?.data?.value || [];
    console.log("res", res.data.errormsg);
    if (res?.data?.errormsg) {
      yield put(setError(res.data.errormsg || "Something wrong!"));
      return;
    }
    yield put(setBullionRates(res.data));
  } catch (err) {
    yield put(
      setError(err.response?.data?.message || "Failed to get bullion rate"),
    );
  }
}
function* fetchBullionRates() {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-rates/getBullionRatesForDashboard?includeHistory=false`,
    );

    const result = response.data;
    const contents = result?.data?.contents || [];

    const disabled = result?.data?.disableCustomerHolding || [];

    const allMetals = [...contents, ...disabled];

    const flatData = allMetals.map((item, index) => {
      const buyRates = item?.currentbuyrate || [];
      const sellRates = item?.currentsellrate || [];

      const buyBullion = buyRates[0]?.bullion || {};
      const sellBullion = sellRates[0]?.bullion || {};

      const marginData = (item?.marginData || []).map((m) => ({
        country: m?.country || null,
        stateDetails: (m?.stateDetails || []).map((s) => ({
          state: s?.state,
          marginType: s?.marginType,
          margin: s?.margin,
          rateType: s?.rateType,
        })),
      }));

      return {
        id: index + 1,

        metalName: buyBullion.metalName || item?.metalName || "",
        purity: buyBullion.purity || item?.purity || "",
        karat: buyBullion.karat || item?.karat || "",

        status: item?.status,

        igst: item?.tax,
        cgst: item?.cgst,
        sgst: item?.sgst,
        cess: item?.cess,

        marginData: marginData,

        currentbuyrate: buyRates,
        currentsellrate: sellRates,
      };
    });

    let states = ["All"];
    result?.data?.states?.forEach((state) => {
      if (!states.includes(state)) {
        states.push(state);
      }
    });

    const legacyBullionRates = result?.data?.bullionRates || {};
    const bullionRateMetals =
      result?.data?.bullionRateMetals?.length
        ? result.data.bullionRateMetals
        : Object.entries(legacyBullionRates).map(([key, rates]) => ({
            _id: rates?.[0]?.bullion?._id,
            key,
          })).filter((metal) => metal._id);

    yield put(
      fetchMetalsSuccess({
        flatData,
        buyRateList: result?.data?.currentBuyRateList,
        sellRateList: result?.data?.currentSellRateList,
        bullionRates: legacyBullionRates,
        bullionRateMetals,
        states: states,
      }),
    );
  } catch (error) {
    yield put(fetchMetalsFailure(error.message));
  }
}

function* handleGetLiveRates() {
  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-rates/getLiveRates`,
    );

    if (res.data.success) {
      yield put(getLiveRatesSuccess(res.data.data));
    } else {
      yield put(getLiveRatesFailure(res.data.message));
      toast.info(res.data.message || "Failed to fetch live rates");
    }
  } catch (error) {
    yield put(
      getLiveRatesFailure(
        error.response?.data?.message || "Live rates API failed",
      ),
    );
    toast.error("Failed to fetch live rates");
  }
}

export function* metalRateSaga() {
  yield takeLatest(addBullionRates.type, handleAddBullionRate);
  yield takeLatest(getMetals.type, handleGetMetals);
  yield takeLatest(getBullionRates.type, handleGetBullionRates);
  yield takeLatest(fetchMetals.type, fetchBullionRates);
  yield takeLatest(getLiveRates.type, handleGetLiveRates);
}
